<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex justify-content-between align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="bx bx-calendar-check me-1 text-primary"></i>Approvals
                                </h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row g-3">
                                <div class="col-md-3">
                                    <label for="name" class="form-label">Employee Name</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-user'></i></span>
                                        <input type="text" class="form-control ps-1" id="name"
                                            placeholder="Employee Name" readonly
                                            [(ngModel)]="employeeAssesment.appraiseeName" autocomplete="off" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="code" class="form-label">Code</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-code-block'></i></span>
                                        <input type="text" class="form-control ps-1" id="code" readonly
                                            [(ngModel)]="employee.employeeData.code" placeholder="Code" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="email" class="form-label">Email</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-envelope'></i></span>
                                        <input type="text" class="form-control ps-1" id="email" name="email" readonly
                                            [(ngModel)]="employee.employeeData.email" placeholder="Email"
                                            autocomplete="email" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="type" class="form-label">Employee Type</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-user-badge'></i></span>
                                        <input type="text" class="form-control ps-1" id="type" readonly
                                            [(ngModel)]="employee.employeeData.employeeType"
                                            placeholder="Employee Type" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="appraisal" class="form-label">Appraisal</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-user-badge'></i></span>
                                        <input type="text" class="form-control ps-1" id="appraisal" readonly
                                            [(ngModel)]="appraisal.label" placeholder="Appraisal" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="start" class="form-label">Start Quarter</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-calendar-event'></i></span>
                                        <input type="text" class="form-control ps-1" id="start" readonly
                                            [(ngModel)]="appraisal.startName" placeholder="Start Quater" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="end" class="form-label">End Quarter</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-calendar-event'></i></span>
                                        <input type="text" class="form-control ps-1" id="end" readonly
                                            [(ngModel)]="appraisal.endName" placeholder="End Quater" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="esub" class="form-label">Employee Submission Day</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-calendar-event'></i></span>
                                        <input type="text" class="form-control ps-1" id="esub" readonly
                                            [(ngModel)]="appraisal.employeeSubDay"
                                            placeholder="Employee Submission Day" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="l1sub" class="form-label">L1 Submission Day</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-calendar-event'></i></span>
                                        <input type="text" class="form-control ps-1" id="l1sub"
                                            [(ngModel)]="appraisal.loneSubDay" readonly
                                            placeholder="L1 Submission Day" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="self" class="form-label">Self Rating</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-star'></i></span>
                                        <input type="text" class="form-control ps-1" id="self" readonly
                                            [(ngModel)]="employeeAssesment.selfRating" placeholder="Self Rating" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="l1Rating" class="form-label">L1 Rating</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-star'></i></span>
                                        <input type="text" class="form-control ps-1" id="l1Rating" readonly
                                            [(ngModel)]="employeeAssesment.loneRating" placeholder="L1 Rating" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="Performance" class="form-label">Performance</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-bar-chart-alt-2'></i></span>
                                        <input type="text" class="form-control ps-1" id="Performance" readonly
                                            [(ngModel)]="employeeAssesment.performanceLabel"
                                            placeholder="Performance" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="matrics" class="form-label">Metrics</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-bar-chart-alt-2'></i></span>
                                        <input type="text" class="form-control ps-1" id="matrics" readonly
                                            [(ngModel)]="employeeAssesment.metricName" placeholder="Metrics" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="hike" class="form-label">Hike</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-bar-chart-alt'></i></span>
                                        <input type="number" class="form-control ps-1" id="hike" readonly
                                            [(ngModel)]="hikeValue" placeholder="Hike" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="promotable" class="form-label">Promotable</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-bar-chart-alt-2'></i></span>
                                        <input type="text" class="form-control ps-1" id="promotable" readonly
                                            [value]="promotableValue?'Yes':'No'" placeholder="Promotable" />
                                    </div>
                                </div>
                                <div class="col-md-9">
                                    <label for="comment" class="form-label">Comment</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-comment'></i></span>
                                        <input type="text" class="form-control ps-1" id="comment" readonly
                                            [(ngModel)]="employeeAssesment.loneComments" placeholder="Comment" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- WIZARD -->
                    <div class="card">
                        <div class="card-body">
                            <kendo-stepper #stepper [steps]="steps" stepType="full" [(currentStep)]="currentStep">
                            </kendo-stepper>
                            <div class="k-form">
                                <app-approval-ratings *ngIf="currentStep === 0" [appraiseeId]="appraiseeId" [status]="appraisalStatus"
                                    [isActive]="isActive" [employeeAssesment]="employeeAssesment"
                                    [appraisalId]="appraisalId" (emitWizardIndex)="handleWizardControls($event)">
                                </app-approval-ratings>
                                <app-approval-performance *ngIf="currentStep === 1" [isActive]="isActive"
                                    [employeeAssesment]="employeeAssesment"
                                    (emitWizardIndex)="handleWizardControls($event)">
                                </app-approval-performance>
                                <app-approval-matrix *ngIf="currentStep === 2" [isActive]="isActive"
                                    [employeeAssesment]="employeeAssesment" (emitWizardIndex)="handleWizardControls($event)">
                                </app-approval-matrix>
                                <app-approval-hike *ngIf="currentStep === 3" [isActive]="isActive"
                                    [employeeAssesment]="employeeAssesment"
                                    (emitWizardIndex)="handleWizardControls($event)">
                                </app-approval-hike>
                                <app-approval-promotable *ngIf="currentStep === 4" [isActive]="isActive"
                                    [employeeAssesment]="employeeAssesment" (emitWizardIndex)="handleWizardControls($event)">
                                </app-approval-promotable>
                                <app-approval-comment *ngIf="currentStep === 5" [isActive]="isActive"
                                    [employeeAssesment]="employeeAssesment" (emitWizardIndex)="handleWizardControls($event)">
                                </app-approval-comment>
                                <span class="k-form-separator"></span>
                                <div class="k-form-buttons k-buttons-end">
                                    <span class="page">Step {{ currentStep + 1 }} of 6</span>
                                    <div class="mt-2">
                                        <button class="btn btn-secondary" *ngIf="currentStep !== 0"
                                            [disabled]="isAssesmentCompleted" (click)="prev()"><ng-container
                                                *ngIf="inProgress?.value!='true'">
                                                <i class='bx bx-skip-previous'></i>
                                            </ng-container>Previous</button>
                                        <button class="btn btn-secondary ms-3" (click)="next()"
                                            *ngIf="currentStep !== 5" [disabled]="isAssesmentCompleted">
                                            <ng-container *ngIf="inProgress?.value!='true'">
                                                <i class="bx bx-save"></i>{{ showSaveButton ? 'Save' : 'Next' }}
                                            </ng-container></button>
                                        <button class="btn btn-success ms-2" (click)="submit()"
                                            *ngIf="currentStep === 5" [disabled]="isActive">
                                            Submit</button>
                                    </div>
                                </div>
                                <div class="row btn-mt">
                                    <div class="col-lg-auto text-start">
                                        <button class="btn btn-secondary btn-sm" [routerLink]="'/appraisal/approval'"
                                            title="Go Back" [disabled]="employeeAssesment.status !== 'LONE_COMPLETED'">
                                            <i class="bx bx-arrow-back"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>